import { MouseEvent, type ReactNode, type Ref } from 'react'
import classNames from 'classnames/bind'
import { reject } from 'ramda'

import styles from './td.module.scss';

/**
 * UI COMPONENTS v2
 *
 * Ячейка таблицы
 * ------
 * Семантически верная таблица. Ячейка таблицы (td)
 */

const cx = classNames.bind(styles)

export type TdProps = {
  children: ReactNode
  className?: string
  stripStyles?: boolean
  stripPadding?: boolean
  alignLeft?: boolean
  alignCenter?: boolean
  alignRight?: boolean
  verticalAlignMiddle?: boolean
  verticalAlignBottom?: boolean
  colSpan?: number
  rowSpan?: number
  reference?: Ref<HTMLTableCellElement | 'td'>
  headers?: string
  first?: boolean
  last?: boolean
  hidden?: boolean
  invisibility?: boolean
  bgFilled?: boolean
  highlighted?: boolean
  bold?: boolean
  ignoreFirstChild?: boolean
  ignoreLastChild?: boolean
  borderLeft?: boolean
  borderRight?: boolean
  style?: { [key: string]: string }
  width?: number
  minWidth?: number
  onMouseEnter?: (e: MouseEvent) => void
  onMouseLeave?: (e: MouseEvent) => void
  ignoreMouseEvents?: boolean
}

const Td = ({
  children,
  className,
  stripStyles,
  stripPadding,
  alignLeft,
  alignCenter,
  alignRight,
  verticalAlignMiddle,
  verticalAlignBottom,
  colSpan,
  rowSpan,
  reference,
  headers,
  first,
  last,
  hidden,
  invisibility,
  bgFilled,
  highlighted,
  bold,
  ignoreFirstChild,
  ignoreLastChild,
  borderLeft,
  borderRight,
  style,
  width,
  minWidth,
  onMouseEnter,
  onMouseLeave,
  ignoreMouseEvents,
}: TdProps) => {
  const cn = {
    root: !stripStyles,
    rootPadding: !stripStyles && !stripPadding,
    alignLeft,
    alignCenter,
    alignRight,
    verticalAlignMiddle,
    verticalAlignBottom,
    first,
    last,
    hidden,
    invisibility,
    bgFilled,
    highlighted,
    bold,
    ignoreFirstChild,
    ignoreLastChild,
    borderLeft,
    borderRight,
  }

  if (hidden) {
    return null
  }

  const styleOverall =
    width || minWidth || style
      ? reject((val) => val === undefined, {
          ...style,
          width,
          maxWidth: width,
          minWidth,
        })
      : undefined

  const mouseEvents = ignoreMouseEvents ? {} : { onMouseEnter, onMouseLeave }

  const props = {
    colSpan,
    rowSpan,
    headers,
    style: styleOverall,
    ...mouseEvents,
  }

  return (
    <td className={cx(cn, className)} ref={reference as Ref<HTMLTableCellElement>} {...props}>
      {children}
    </td>
  )
}

export default Td
